const logo = "/superagro-logo.png";
const serverUrl = "https://api.superagrodig.com";

export { serverUrl, logo };
